import {IAppState} from './interface';
import { user } from './state/user';
import { organization } from './state/organization';
import { projects } from './state/projects';
import { projectDetails } from './state/projectDetails';

export const appModel: IAppState = {
  user,
  organization,
  projects,
  projectDetails,
};
